import { render } from "./resSelectVehicle.vue?vue&type=template&id=5d989058&scoped=true"
import script from "./resSelectVehicle.vue?vue&type=script&lang=js"
export * from "./resSelectVehicle.vue?vue&type=script&lang=js"

import "./resSelectVehicle.vue?vue&type=style&index=0&id=5d989058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d989058"]])

export default __exports__